<script>
import {
  onUnauthenticatedPages,
  onProfilePages,
  onProjectsPage,
  onPasswordResetPage,
} from '@/util/routesHelper.js'

export default {
name: "LoadSettingsMixin"
  ,
  data() {
    return {
      settings_loaded: false
    }
  },
  mounted() {
    this.load_settings();
  },
  watch: {
    '$store.state.user.project_id'() {
      this.settings_loaded = false;
      this.load_settings({ force_reload: true });
    },
  },
  computed: {
    settings () {
      return this.$store.getters['setting/get_items']
    },
    'instances_enabled'() {
      return this.$store.getters['setting/get_setting']('instances_enabled')
    },
    'simple_mode'() {
      return this.$store.getters['setting/get_setting']('simple_mode')
    },
    // Define guards on the mixin so hosts like MenuBar (which lack
    // MainSideMenu's on_profile_page) do not call /api/settings on profile
    // pages without a project_id and bounce to login (issue #18 regression).
    on_unauthenticated_pages() {
      return onUnauthenticatedPages.call(this);
    },
    on_profile_page() {
      return onProfilePages.call(this);
    },
    on_password_reset_page() {
      return onPasswordResetPage.call(this);
    },
    on_project_page() {
      return onProjectsPage.call(this);
    },
  },
  methods: {
    async load_settings(payload) {
      if(this.on_profile_page) {
        return;
      }
      if(this.on_unauthenticated_pages) {
        return;
      }
      if(this.on_password_reset_page) {
        return;
      }
      if(this.on_project_page) {
        return;
      }
      // Settings are project-scoped; skip when no project is selected.
      const projectId = this.$store.getters['user/get_current_project_id'];
      if (!projectId || projectId === 'false' || projectId === false) {
        return;
      }
      await this.$store.dispatch('setting/all', payload || { force_reload: true })
      this.settings_loaded = true
    },
    async set_simple_mode(enabled) {
      await this.$store.dispatch('setting/patch_setting', {
        k: 'simple_mode',
        v: enabled ? 'true' : 'false',
      });
      await this.$store.dispatch('setting/all', { force_reload: true });
    },
  }
}
</script>

<style scoped>

</style>
